import axios, { AxiosRequestConfig } from 'axios';
import { authManager, createAuthorizationHeaderValue } from 'lib-shared-auth';

import {
  elevioUrls,
  getBackendDomain,
  resolveElevioUrlByEnvironment,
} from '../../../index';

export type ElevioAuthTokenResponse = {
  readonly elevioToken: string;
};

const backendDomain = getBackendDomain();
const ELEVIO_DIXA_SSO_PATH = resolveElevioUrlByEnvironment(
  {
    production: elevioUrls.production.sso,
    staging: elevioUrls.staging.sso,
  },
  backendDomain,
);

/** Queries Elevio API using a Dixa token, returns ElevioAuthTokenResponse */
export async function fetchElevioAuthToken(): Promise<ElevioAuthTokenResponse> {
  const auth = await authManager.getAuthData();
  if (!auth) throw new Error('No auth data found');
  if (!auth.refresh_token) throw new Error('No refresh token found');

  const config: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: await createAuthorizationHeaderValue(),
    },
  };

  const response = await axios.post<ElevioAuthTokenResponse>(
    ELEVIO_DIXA_SSO_PATH,
    {},
    config,
  );

  return {
    elevioToken: response.data.elevioToken,
  };
}
